export default __webpack_public_path__ + "static/media/male.744fb8fa.png";